// extracted by mini-css-extract-plugin
module.exports = {"BubbleContainer":"bubbleContainer_BubbleContainer__2MshK","StartAlign":"bubbleContainer_StartAlign__3risL","EndAlign":"bubbleContainer_EndAlign__31U6Q"};